<template>
  <BaseButton type="button" secondary outline small :disabled="pending" @click="execute">
    Cancel Syncronization <Loader small v-if="pending" />
  </BaseButton>
</template>

<script>
import { contactListCancelledJobBatchesClient } from '@/api/clients';

export default {
  props: {
    contactListId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pending: false,
    };
  },
  methods: {
    execute() {
      this.pending = true;
      contactListCancelledJobBatchesClient
        .store(this.contactListId, { cancel_all: true })
        .then((response) => {
          this.$router.replace({
            path: this.$route.path,
            query: {
              updated: new Date().getTime(),
            },
          });
          return Promise.resolve(response);
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
};
</script>
